import styles from "./DesignBoxAllItems.module.css";
import DesignBoxConfirmationTable from "./DesignBoxThirdFolderConfirmation/DesignBoxConfirmationTable";
import DesignBoxTabSection from "./DesignBoxTabForFolderFirstSecond/DesignBoxTabSection";
import { useEffect, useState } from "react";
import axios from "axios";
const DesignBoxAllItems = ({
  active,
  edited_products,
  unedited_products,
  setshowWarningIconOnUneditedTab,
  setshowWarningIconOnConfirmedTab,
}) => {
  const [confirmedItems, setConfirmedItems] = useState([]);
  const noUneditedProducts =
    unedited_products?.default?.length === 0 &&
    unedited_products?.address_1?.length === 0 &&
    unedited_products?.address_2?.length === 0;

  const noEditedProducts =
    edited_products?.default?.length === 0 &&
    edited_products?.address_1?.length === 0 &&
    edited_products?.address_2?.length === 0;

  setshowWarningIconOnUneditedTab(!noUneditedProducts);

  const { access } = JSON.parse(localStorage.getItem("authTokens"));
  useEffect(() => {
    // Function to fetch data from the API
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/design/final`,
          {
            headers: {
              Authorization: `Bearer ${access}`,
            },
          }
        );
        setConfirmedItems(response.data);
        setshowWarningIconOnConfirmedTab(response.data?.length > 0);

        // setLoading(false);
        console.log(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
        // setError("Error fetching data. Please try again later.");
        // setLoading(false);
      }
    };

    fetchData();
  }, [access]);

  // active: 1 => Unedited
  //     2 => Edited
  //     3 => Shipping
  if (active === 1) {
    return (
      <>
        <div className={styles.all_items_unedited_main_div}>
          {!noUneditedProducts &&
            Object.keys(unedited_products).map((item, index) => {
              return (
                // This is the first folder of design box. *** unedited folder
                <DesignBoxTabSection
                  key={index + "unedited_data"}
                  buttonHeader={
                    item === "default"
                      ? "会員様住所へ配送"
                      : item === "address_1"
                      ? "別送住所1へ配送"
                      : "別送住所2へ配送"
                  }
                  items={unedited_products[item]}
                  activeTabNumber={active}
                />
              );
            })}
          {noUneditedProducts && (
            <div className={styles.noItemTxt}>未編集の項目はありません。</div>
          )}
          )
        </div>
      </>
    );
  } else if (active === 2) {
    return (
      <>
        <div className={styles.all_items_unedited_main_div}>
          {!noEditedProducts &&
            Object.keys(edited_products).map((item, index) => {
              return (
                // This is the second folder of design box. *** Edited folder
                <DesignBoxTabSection
                  key={index + "edited_data"}
                  buttonHeader={
                    item === "default"
                      ? "会員様住所へ配送"
                      : item === "address_1"
                      ? "別送住所1へ配送"
                      : "別送住所2へ配送"
                  }
                  items={edited_products[item]}
                  activeTabNumber={active}
                />
              );
            })}
          {noEditedProducts && (
            <div className={styles.noItemTxt}>
              編集済みのアイテムは全て発送済みです。
              <br />
              確認するアイテムはありません。
            </div>
          )}
        </div>
      </>
    );
  } else if (active === 3) {
    return (
      // This is the third folder of design box. *** Confirmation folder
      <>
        <div className={styles.all_items_confirmation_main_div}>
          <div className={styles.items_confirmation_div}>
            <DesignBoxConfirmationTable items={confirmedItems} />
          </div>
        </div>
      </>
    );
  } else return <></>;
};

export default DesignBoxAllItems;
